import React from 'react';
import styled from 'styled-components';

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

const Label = styled.label`
  font-size: 0.75rem;
  font-weight: 600;
  color: ${(p) => p.theme.textSecondary};

  .req {
    color: ${(p) => p.theme.error};
    margin-left: 0.15rem;
  }
`;

const Field = styled.input<{ $error?: boolean }>`
  width: 100%;
  box-sizing: border-box;
  min-height: 42px;
  padding: 0.6rem 0.75rem;
  font-size: 0.9rem;
  font-family: inherit;
  color: ${(p) => p.theme.textPrimary};
  background: ${(p) => p.theme.surface};
  border: 1px solid ${(p) => (p.$error ? p.theme.error : p.theme.border)};
  border-radius: ${(p) => p.theme.radius};
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: ${(p) => p.theme.textMuted};
  }
  &:focus {
    outline: none;
    border-color: ${(p) => p.theme.primary};
    box-shadow: 0 0 0 3px ${(p) => p.theme.primary}22;
  }
  &:disabled {
    background: ${(p) => p.theme.surfaceAlt};
    cursor: not-allowed;
  }
`;

const ErrorText = styled.span`
  font-size: 0.75rem;
  color: ${(p) => p.theme.error};
`;

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  containerStyle?: React.CSSProperties;
}

export const TextInput: React.FC<TextInputProps> = ({
  label,
  error,
  required,
  containerStyle,
  id,
  ...rest
}) => (
  <Group style={containerStyle}>
    {label && (
      <Label htmlFor={id}>
        {label}
        {required && <span className="req">*</span>}
      </Label>
    )}
    <Field id={id} $error={!!error} required={required} {...rest} />
    {error && <ErrorText>{error}</ErrorText>}
  </Group>
);

export default TextInput;
